export default [
    {
        path: '/postbacks',
        name: 'PagePostbacksList',
        meta: { title: 'postbacks.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['postbacks'] },
        component: () => import('@/pages/postbacks'),
    },
]